import React from 'react';
import BannerSection from '../sections/banner-section';
import BannerEditModal from './modals/banner-edit-modal';
import ServiceSections from '../sections/service-sections';
import ServiceEditModal from './modals/service-edit-modal';
import PrioritizeSection from '../sections/prioritize-section';
import PrioritizeEditModal from './modals/prioritize-edit-modal';
import ReviewSection from '../sections/review-section';
import ReviewEditModal from '@/pages/home-3/edit/modals/review-edit-modal';
import AboutWeSection from '../sections/about-we-section';
import AboutWeEditModal from './modals/about-we-edit-modal';
import HowWeWorksSection from '../sections/how-we-works-section';
import HowWeWorksEditModal from './modals/how-we-works-edit-modal';
import BusinessPersonalSection from '../sections/business-personal-section';
import BusinessPersonalEditModal from './modals/business-personal-edit-modal';
import ClientTestimonials from '../sections/client-testimonials';
import ClientTestimonialsEditModal from './modals/client-testimonials-edit-modal';
import MobileAppSection from '../sections/mobile-app-section';
import MobileAppEditModal from '@/pages/home-3/edit/modals/mobile-app-edit-modal';
import TrustExpertsSection from '../sections/trust-experts-section';
import TrustExpertsEditModal from './modals/trust-experts-edit-modal';
import Header4 from '@/feature-module/common/header/header-4';
import Header4EditModal from '@/feature-module/common/header/edit/modals/header4-edit-modal';
import ReviewSectionEditModal from './modals/review-section-edit-modal';
import MobileAppSectionEditModal from './modals/mobile-app-edit-modal';

const Home4Edit = ({ themeData, fetchData }: any) => {
  return (
    <>
      {/* <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#headerEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <>
          <Header4 themeData={themeData} />
        </>
      </div> */}
      {/* <div
        className="modal fade"
        id="headerEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <Header4EditModal themeData={themeData} fetchData={fetchData} />
      </div> */}
      <div className="section-editor">
        <BannerSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="bannerEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <BannerEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#serviceFourEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <ServiceSections themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="serviceFourEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <ServiceEditModal themeData={themeData} getThemeData={fetchData} />
      </div>      

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#trustExpertsEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <TrustExpertsSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="trustExpertsEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <TrustExpertsEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#reviewEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <ReviewSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="reviewEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <ReviewSectionEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#aboutWeEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <AboutWeSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="aboutWeEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <AboutWeEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor home_4_main_wrapper ">
        <a
          data-bs-toggle="modal"
          data-bs-target="#howWeWorksEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <HowWeWorksSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="howWeWorksEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <HowWeWorksEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor home_4_main_wrapper">
        <a
          data-bs-toggle="modal"
          data-bs-target="#bussinessPersonalEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <BusinessPersonalSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="bussinessPersonalEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <BusinessPersonalEditModal
          themeData={themeData}
          getThemeData={fetchData}
        />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#prioritizeEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <PrioritizeSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="prioritizeEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <PrioritizeEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#clientTestimonialsEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <ClientTestimonials themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="clientTestimonialsEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <ClientTestimonialsEditModal
          themeData={themeData}
          getThemeData={fetchData}
        />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#mobileAppEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <MobileAppSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="mobileAppEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <MobileAppSectionEditModal themeData={themeData} getThemeData={fetchData} />
      </div>
    </>
  );
};

export default Home4Edit;
